import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { DialogActions, DialogContent, DialogTitle, Typography, } from '@mui/material';
import clsx from 'clsx';
import CloseIcon from '@mui/icons-material/Cancel';
import Modal from '../modal/Modal';
import modalWithHeaderStyles from './modalWithHeader.styles';
const ModalWithHeader = memo(({ open, toggleModal, title = false, content, actions, onClose, classes, }) => {
    const styles = modalWithHeaderStyles();
    const handleOnClose = useCallback(() => {
        toggleModal(false);
        if (onClose) {
            onClose();
        }
    }, []);
    return (_jsxs(Modal, { PaperProps: { className: clsx([styles.modalRoot, classes?.modalRoot]) }, open: open, toggleModal: toggleModal, hideCloseIcon: true, children: [_jsxs(DialogTitle, { className: clsx([styles.closeContainer, classes?.closeContainer]), children: [_jsx(Typography, { "data-test": "text:modal:title", align: 'center', className: clsx([styles.title, classes?.title]), variant: "h4", children: title }, void 0), _jsx("span", { className: clsx([styles.closeButton, classes?.closeButton]), onClick: handleOnClose, children: _jsx(CloseIcon, { "data-test": "button:close", className: clsx([styles.icon, classes?.icon]) }, void 0) }, void 0)] }, void 0), _jsx(DialogContent, { className: clsx([styles.content, classes?.content]), children: content }, void 0), actions && (_jsx(DialogActions, { className: clsx([
                    styles.actionsContainer,
                    classes?.actionsContainer,
                ]), children: actions }, void 0))] }, void 0));
});
export default ModalWithHeader;
//# sourceMappingURL=ModalWithHeader.js.map